import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'dmp-export-table-edit',
    templateUrl: './export-table-edit.component.html',
    styleUrls: ['./export-table-edit.component.scss'],
    standalone: false
})
export class ExportTableEditComponent implements OnInit {

  list1: any[];

    list2: any[];

  constructor() { }

  ngOnInit() {
    this.list1 = [{
      brand: "brand",
      year: "year",
      color: "color"
    }]
        this.list2 = []
  }

}
